import axios from "axios";
import {disconnectUser} from "../store/cabinet/action";
import { store } from '../store';


axios.interceptors.request.use(function (config) {
    const lng = localStorage.getItem('launchpadLng');
    if (lng && config.url.indexOf('lang') === -1){
        if (config.url.indexOf('?') === -1){
            config.url = config.url + `?lang=${lng}`
        } else {
            config.url = config.url + `&lang=${lng}`
        }
    }
    return config;
}, function (error) {

    return Promise.reject(error);
});

// Add a response interceptor
axios.interceptors.response.use(function (response) {

    return response;
}, function (error) {
    if (error.response.status === 401 || error.response.status === 429){
        store.dispatch(disconnectUser());
    }
    return Promise.reject(error);
});


export default axios;